import script from "./ShowLargeImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShowLargeImage.vue?vue&type=script&lang=ts&setup=true"

import "./ShowLargeImage.vue?vue&type=style&index=0&id=5c0ec57a&lang=scss"

const __exports__ = script;

export default __exports__